import { cn } from "@/lib/utils";
import { useI18n } from "@/lib/i18n";

const CLASSES = {
  buy: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  sell: "bg-red-500/10 text-red-400 border-red-500/30",
  hold: "bg-amber-500/10 text-amber-400 border-amber-500/30",
};

export default function SignalBadge({ signal, confidence, size = "md" }) {
  const { t } = useI18n();
  const classes = CLASSES[signal] || CLASSES.hold;
  return (
    <div
      className={cn(
        "inline-flex items-center gap-2 border rounded-sm font-bold tracking-tight",
        classes,
        size === "lg" ? "px-4 py-2 text-base" : "px-2.5 py-1 text-xs"
      )}
      data-testid={`signal-badge-${signal}`}
    >
      <span className={cn("w-1.5 h-1.5 rounded-full",
        signal === "buy" && "bg-emerald-400",
        signal === "sell" && "bg-red-400",
        signal === "hold" && "bg-amber-400",
      )} />
      <span>{t(signal)}</span>
      {typeof confidence === "number" && (
        <span className="num text-[10px] opacity-80">{confidence}%</span>
      )}
    </div>
  );
}
